import customerConverter from 'models/Customer/converter'
import getCollectionByName from 'actions/base/getCollectionByName'

const getCollection = (withConverter = true) =>
  getCollectionByName('customers', withConverter ? customerConverter : null)

export default getCollection
